import { render, staticRenderFns } from "./SlideCourse.vue?vue&type=template&id=4a06039a&scoped=true"
import script from "./SlideCourse.vue?vue&type=script&lang=js"
export * from "./SlideCourse.vue?vue&type=script&lang=js"
import style0 from "./SlideCourse.vue?vue&type=style&index=0&id=4a06039a&prod&scoped=true&lang=css"
import style1 from "./SlideCourse.vue?vue&type=style&index=1&id=4a06039a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a06039a",
  null
  
)

export default component.exports